import { addShowtimeIdsForQueryOnBusinessDate, configurationSettings, createFetchedData, getScreeningDatesForQuery, loadShowtimesForBusinessDate, logger } from '@vista/omnichannel-components-domain';
import { DateShowtimePickerActionType as ActionType } from './action-type';
/**
 * Action performed when a date is selected in the date picker
 */
export const handleDateSelected = async (query, businessDate, dispatch) => {
    // Check if selected date is a Screening Date to void calling API when we know there will be no showtimes.
    const screeningDates = getScreeningDatesForQuery(query);
    if (screeningDates) {
        const dates = screeningDates.map(date => date.businessDate);
        if (dates.length && !dates.includes(businessDate)) {
            const emptyShowtimesData = createFetchedData([], configurationSettings.data.cache.durations.showtimes);
            addShowtimeIdsForQueryOnBusinessDate(emptyShowtimesData, query, businessDate);
            return;
        }
    }
    dispatch({ type: ActionType.Loading });
    // Date exists in screening dates, call API
    try {
        await loadShowtimesForBusinessDate(query, businessDate);
        dispatch({ type: ActionType.Loaded });
    }
    catch (error) {
        logger.error('Get Showtimes Error:', error);
        dispatch({ type: ActionType.FailedToLoad, error: error });
    }
};
